module.exports = __webpack_public_path__ + "static/img/ic_draw_1.dbc8ab4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_draw_1.png
// module id = Psr2
// module chunks = 0